import { IJsonSerializable } from "./interfaces"

export class OpExportData implements IJsonSerializable {

    //#region Properties

    public headers: string[]
    public data: any[][]

    //#endregion

    //#region Ctor

    public constructor(obj: any = null) {
        this.fromJSON(obj)

    }

    //#endregion

    //#region IJsonSerializable

    public fromJSON(obj: any, compressed: boolean = false): void {
        if (obj != null) {
            this.headers = obj.Headers
            this.data = obj.Data
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            Headers: this.headers,
            Data: this.data
        }
    }

    //#endregion
}